export enum CardLabelType {
  DOCUMENT = 'Document',
  ARTICLE = 'Article',
  URL = 'Url',
  VIDEO = 'Video',
}
